"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Slider from "react-slick";
import { forwardRef, useMultiStyleConfig, Box, useBreakpointValue, } from "@chakra-ui/react";
import { Display } from "./Carousel.types";
import { ButtonVariant, IconButton, SvgSpriteConsumer } from "../../atoms";
const CustomDot = ({ display }) => (_jsx(Box, { "aria-label": "carousel-element", as: "button", sx: Object.assign({}, (display === Display.mobile ? { pointerEvents: "none" } : {})) }));
const Carousel = forwardRef((_a, ref) => {
    var { title, elements, variant = "md", onChange, dots = true, arrows = false, nextArrow, prevArrow } = _a, rest = __rest(_a, ["title", "elements", "variant", "onChange", "dots", "arrows", "nextArrow", "prevArrow"]);
    const display = useBreakpointValue({
        sm: Display.mobile,
        md: Display.desktop,
    }, {
        fallback: "md",
    });
    const styles = useMultiStyleConfig("Carousel", { variant, dots, arrows });
    const defaultSettings = Object.assign(Object.assign({ customPaging: () => CustomDot({
            display: display,
        }), infinite: true, slidesToShow: 1, swipeToSlide: true, dots,
        arrows, speed: 500, slidesToScroll: 1, initialSlide: 0 }, (arrows
        ? {
            nextArrow: nextArrow || (_jsx(IconButton, { "aria-label": ButtonVariant.SECONDARY_TEXT_ONLY, variant: ButtonVariant.SECONDARY_TEXT_ONLY, icon: _jsx(SvgSpriteConsumer, { svgId: "chevronRight24", size: 24 }) })),
            prevArrow: prevArrow || (_jsx(IconButton, { "aria-label": ButtonVariant.SECONDARY_TEXT_ONLY, variant: ButtonVariant.SECONDARY_TEXT_ONLY, icon: _jsx(SvgSpriteConsumer, { svgId: "chevronLeft24", size: 24 }) })),
        }
        : {})), { afterChange: (index) => onChange === null || onChange === void 0 ? void 0 : onChange(index) });
    return (_jsxs(Box, Object.assign({ sx: styles.container }, { children: [title ? _jsx(Box, Object.assign({ sx: styles.title }, { children: title })) : null, _jsx(Box, Object.assign({ sx: styles.carousel }, { children: _jsx(Slider, Object.assign({ ref: ref }, defaultSettings, rest, { children: elements.map((item, index) => (_jsx(Box, Object.assign({ className: "custom-slider" }, { children: item }), index))) })) }))] })));
});
Carousel.displayName = "Carousel";
export default Carousel;
//# sourceMappingURL=Carousel.js.map